import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=191e6f1a&scoped=true"
import script from "./ability.vue?vue&type=script&lang=js"
export * from "./ability.vue?vue&type=script&lang=js"
import style0 from "./ability.vue?vue&type=style&index=0&id=191e6f1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e6f1a",
  null
  
)

export default component.exports